import { render } from "./Leads.vue?vue&type=template&id=1b083f76&scoped=true&ts=true&lang=pug"
import script from "./Leads.vue?vue&type=script&lang=ts&setup=true"
export * from "./Leads.vue?vue&type=script&lang=ts&setup=true"

import "./Leads.vue?vue&type=style&index=0&id=1b083f76&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b083f76"]])

export default __exports__